
import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  textColor?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ size = 32, className = '', showText = false, textColor = 'dark' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div 
        className="relative flex-shrink-0"
        style={{ width: size, height: size }}
      >
        <svg 
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full drop-shadow-md"
        >
          {/* Bottom Layer */}
          <path 
            d="M20 55L50 40L80 55L50 70L20 55Z" 
            fill="#1e293b" 
            className="opacity-40"
          />
          {/* Middle Layer */}
          <path 
            d="M20 45L50 30L80 45L50 60L20 45Z" 
            fill="#3b82f6" 
            className="opacity-70"
          />
          {/* Top Layer */}
          <path 
            d="M20 35L50 20L80 35L50 50L20 35Z" 
            fill="url(#logoGradient)"
          />
          {/* Grid lines on top layer */}
          <path 
            d="M35 27.5L65 42.5 M50 20L50 50 M35 42.5L65 27.5" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            className="opacity-30"
          />
          
          <defs>
            <linearGradient id="logoGradient" x1="20" y1="20" x2="80" y2="50" gradientUnits="userSpaceOnUse">
              <stop stopColor="#60a5fa" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`text-xl font-black tracking-tighter leading-none ${textColor === 'dark' ? 'text-slate-900' : 'text-white'}`}>
            Plan<span className="text-blue-600">Stack</span>
          </span>
          <span className={`text-[7px] font-black uppercase tracking-[0.2em] mt-1 ${textColor === 'dark' ? 'text-slate-400' : 'text-slate-300 opacity-60'}`}>
            Developer Assistant & Business Directory
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
